<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
  body {
    background-color: #f6f6f9;
  }
  .mgtb20 {
    margin: 20px 0;
  }
  .mgc10 {
    margin: 10px auto;
  }
  .flex {
    display: flex;
  }
  .justify-center {
    justify-content: center;
  }
  .space-between {
    justify-content: space-between;
  }
  .flex-end {
    justify-content: flex-end;
  }
  .relative {
    position: relative;
  }
  .absolute {
    position: absolute;
  }
  .cursor-pointer {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue